import React, { useEffect } from 'react'
import { ScrollToError } from '@src/components/AdvertisingCampaign/Form/ScrollToFirstError'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./BriefForm.css'))

const BriefForm = props => {
  const { handleSubmit, values, sendStartFillingBriefAnalytics, children } = props

  useEffect(() => {
    return () => sendStartFillingBriefAnalytics()
  }, [values])

  useEffect(() => {
    window.reactInitCaptcha && window.reactInitCaptcha()
  }, [])

  return (
    <form
      className={bem.b('BriefForm').show()}
      onSubmit={handleSubmit}
      id="brief-create-form"
      name="brief_create_form"
      data-recaptcha-action="brief_create_form_message"
    >
      <div
        className={bem
          .b('BriefForm')
          .e('container')
          .show()}
      >
        {children}
        <ScrollToError />
      </div>
      <div
        className={`${bem
          .b('BriefForm')
          .e('recaptcha')
          .show()} g-recaptcha g-recaptcha--react`}
      />
    </form>
  )
}

export default BriefForm
